import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import ShareThisLibraryToast from '@components/ContentLibrary/TitleBar/Buttons/ShareThisLibraryButton/Toast'
import ShareableContentLibraryTrackedRoute from '@components/ShareableContentLibrary/TrackedRoute'
import { EventTrackingNames } from '@enums'
import { IApplicationState } from '@store'
import { selectShareableContentLibraryTotal } from '@store/mediaObjects'
import { Button, Header, Toaster } from '@tribegroup'
import { clipboard } from '@utils'

const ShareThisLibrary: React.FC = () => {
  const librarySize = useSelector((state: IApplicationState) =>
    selectShareableContentLibraryTotal(state),
  )
  const onClick = async () => {
    await clipboard.copy(window.location.href)
    Toaster.createToast(ShareThisLibraryToast)
  }
  return (
    <ShareableContentLibraryTrackedRoute
      eventName={EventTrackingNames.ShareableCLShareCLButton}
      additionalProperties={{ library_size: librarySize }}
    >
      <Button scheme="primary" small width={11.5625} onClick={onClick} noFocus>
        <Header cta small>
          <FormattedMessage id="contentLibrary.shareable.shareThis" />
        </Header>
      </Button>
    </ShareableContentLibraryTrackedRoute>
  )
}

export { ShareThisLibrary }
export default ShareThisLibrary
